import { AppContext } from '../../../contexts/AppContext';
import { Link } from 'react-router';
import { useContext } from 'react';

export type IntranetButtonProps = {
    onClick: () => void,
    extraClasses?: string,
}

export const IntranetButton = (props: IntranetButtonProps) => ( 
    useContext(AppContext).baseFeatures?.IsIntranetDisplay && <Link onClick={props?.onClick} to="/intranet" className={`btn btn-info ${props.extraClasses}`}>
        Intranet
    </Link>
);